import { BasicLayout } from '@/layout'

const articleRouter = {
  path: '/article',
  name: 'Article',
  alwaysShow: true,
  component: BasicLayout,
  redirect: 'noRedirect',
  meta: { title: '内容管理', icon: 'excel' },
  children: [
    {
      path: 'index',
      name: 'ArticleIndex',
      meta: { title: '文章列表' },
      component: () => import('@/views/article/article')
    },
    {
      hidden: true,
      path: 'edit',
      name: 'ArticleEdit',
      component: () => import('@/views/article/edit'),
      meta: { title: '编辑文章', keepAlive: true, activeMenu: '/article/index' }
    },
    {
      path: 'banner',
      name: 'ArticleBanner',
      meta: { title: '轮播图管理' },
      component: () => import('@/views/article/banner')
    },
    {
      path: 'refundReason',
      name: 'ArticleRefundReason',
      meta: { title: '退款原因管理' },
      component: () => import('@/views/article/refundreason')
    // },
    // {
    //   path: 'storage',
    //   name: 'ArticleStorage',
    //   meta: { title: '素材管理' },
    //   component: () => import('@/views/article/objectstorage')
    }
  ]
}

export default articleRouter
